// Minimal assert polyfill for browser builds. Not feature-complete but covers
// the subset exercised by bundled dependencies at runtime.

function formatValue(value) {
  try {
    return typeof value === "string" ? `"${value}"` : JSON.stringify(value);
  } catch (_) {
    return String(value);
  }
}

function createError(message) {
  const error = new Error(message || "Assertion failed");
  error.name = "AssertionError";
  return error;
}

function fail(actual, expected, message, operator) {
  const defaultMessage = `${formatValue(actual)} ${operator || "==="} ${formatValue(expected)}`;
  throw createError(message || `Assertion failed: ${defaultMessage}`);
}

function ok(value, message) {
  if (!value) {
    throw createError(message || "Assertion failed");
  }
}

function equal(actual, expected, message) {
  if (actual != expected) {
    fail(actual, expected, message, "==");
  }
}

function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, "===");
  }
}

function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, "!==");
  }
}

function deepStrictEqual(actual, expected, message) {
  const actualStr = formatValue(actual);
  const expectedStr = formatValue(expected);
  if (actualStr !== expectedStr) {
    fail(actual, expected, message, "deep===");
  }
}

function notDeepStrictEqual(actual, expected, message) {
  const actualStr = formatValue(actual);
  const expectedStr = formatValue(expected);
  if (actualStr === expectedStr) {
    fail(actual, expected, message, "deep!==");
  }
}

const assert = function assert(value, message) {
  ok(value, message);
};

assert.ok = ok;
assert.equal = equal;
assert.strictEqual = strictEqual;
assert.notStrictEqual = notStrictEqual;
assert.deepStrictEqual = deepStrictEqual;
assert.notDeepStrictEqual = notDeepStrictEqual;
assert.fail = (message) => {
  throw createError(message);
};

module.exports = assert;
